/* COMPRE E GANHE v11 - BPM Theme */
;(function(){

/* =========================================================
   CONFIG
   ========================================================= */
function lerConfig(){
  var el=document.getElementById('ceg-section-config');
  if(!el)return null;
  try{
    var sc=JSON.parse(el.textContent);
    if(!sc||!sc.ativo)return null;

    var rules={};
    var valorRules=[];

    (sc.regras||[]).forEach(function(r){
      if(r.tipo==='valor'){
        if(r.valor_minimo&&r.brindes&&r.brindes.length)
          valorRules.push({valor_minimo:r.valor_minimo,brindes:r.brindes});
        return;
      }
      if(!r.produto_elegivel)return;
      if(r.brindes&&r.brindes.length)   rules[r.produto_elegivel]=r.brindes;
      else if(r.produto_brinde)          rules[r.produto_elegivel]=r.produto_brinde;
    });

    valorRules.sort(function(a,b){return b.valor_minimo-a.valor_minimo;});

    if(!Object.keys(rules).length&&!valorRules.length){
      console.warn('[CEG] Nenhuma regra configurada. Verifique se produto_brinde_1 esta preenchido em cada regra.');
      return null;
    }

    // Avisa se regra de colecao existe mas produto_brinde_1 esta vazio
    // (o liquid nao gera a regra nesse caso — regra fica silenciosamente inativa)
    if(!Object.keys(rules).length&&valorRules.length){
      console.warn('[CEG] Nenhuma regra de produto/colecao ativa. Se configurou regra de colecao, verifique se Brinde 1 esta preenchido.');
    }

    var t=sc.textos||{};
    return{
      rules:rules,
      valorRules:valorRules,
      GIFT_PROP:'_gift',
      GIFT_FROM:'_gift_from',
      GIFT_FROM_VALOR:'_gift_from_valor',
      txt:{
        title:       t.titulo         ||'Brinde desbloqueado',
        subtitle:    t.subtitulo      ||'Selecione um item para receber gratuitamente com sua compra',
        btnSelect:   t.btn_selecionar ||'Selecionar brinde',
        btnDecline:  t.btn_recusar    ||'Nao quero brinde',
        confirmTitle:t.confirm_titulo ||'Ue, nao quer brinde?',
        confirmText: t.confirm_texto  ||'E sua chance de completar seu armario.',
        confirmNo:   t.confirm_nao    ||'Tenho certeza, nao quero brinde',
        confirmYes:  t.confirm_sim    ||'Quero brinde sim, cliquei errado'
      }
    };
  }catch(e){console.error('[CEG] Erro config:',e);return null;}
}

/* =========================================================
   ESTADO
   ========================================================= */
var S={
  config:null,
  overlay:null,
  confirm:null,
  isOpen:false,
  isConfirm:false,
  isAdding:false,
  isValorRule:false,
  valorMinimo:null,
  triggerHandle:null,
  brindes:[],
  selectedBrindeHandle:null,
  selectedVariantId:null,
  afterClose:null,
  timers:{}
};

/* =========================================================
   UTILITARIOS
   ========================================================= */
function debounce(k,fn,ms){
  clearTimeout(S.timers[k]);
  S.timers[k]=setTimeout(fn,ms);
}
function fmt(cents){
  if(!cents)return'R$ 0,00';
  return'R$ '+(cents/100).toFixed(2).replace('.',',');
}
function isGiftPayload(body){
  if(!body)return false;
  try{
    var p=typeof body==='string'?JSON.parse(body):null;
    if(p&&p.properties&&p.properties[S.config.GIFT_PROP]==='true')return true;
  }catch(e){}
  if(typeof FormData!=='undefined'&&body instanceof FormData&&
     body.get('properties['+S.config.GIFT_PROP+']')==='true')return true;
  return false;
}

/* =========================================================
   TOTAL DO CARRINHO — usa o estado atual do carrinho
   que o tema BPM mantém vivo no drawer
   ========================================================= */
function calcularTotalAtual(callback){
  // Tenta pegar do drawer do BPM que já está no DOM (sem novo fetch)
  var items=[];
  try{
    var cartDrawer=document.getElementById('cartDrawer')||document.getElementById('ajaxDrawer');
    if(cartDrawer){
      cartDrawer.querySelectorAll('.cart-item[data-line-price]').forEach(function(el){
        var lp=parseInt(el.getAttribute('data-line-price')||'0',10);
        var gift=el.getAttribute('data-gift')||el.dataset.gift||'';
        if(!gift)items.push(lp);
      });
      // Se conseguiu ler do DOM, usa direto
      if(items.length){
        var total=items.reduce(function(a,b){return a+b;},0);
        console.info('[CEG] Total do DOM do drawer:',total);
        callback(total);
        return;
      }
    }
  }catch(e){}

  // Fallback: lê do /cart.js (mesmo comportamento da regra de coleção)
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=0;
    (cart.items||[]).forEach(function(i){
      if(i.properties&&i.properties[S.config.GIFT_PROP]==='true')return;
      total+=i.line_price;
    });
    console.info('[CEG] Total via /cart.js:',total);
    callback(total);
  }).catch(function(){callback(0);});
}

/* =========================================================
   CHECAR SE JÁ TEM BRINDE NO CARRINHO
   Igual à lógica da regra de coleção — lê propriedades
   do item na resposta do cart/add ou do DOM
   ========================================================= */
function cartTemBrinde(handle, isValor){
  return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    return (cart.items||[]).some(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')return false;
      if(isValor) return i.properties[S.config.GIFT_FROM_VALOR]===''+handle;
      return i.properties[S.config.GIFT_FROM]===handle;
    });
  }).catch(function(){return false;});
}

/* =========================================================
   LÓGICA PRINCIPAL — igual à regra de coleção
   Recebe o total já calculado da resposta do cart
   e decide abrir ou não o popup
   ========================================================= */
function checarRegrasValorComTotal(total){
  if(!S.config.valorRules.length)return;
  if(S.isOpen||S.isConfirm)return;

  // Encontra maior threshold elegível
  var regra=null;
  for(var i=0;i<S.config.valorRules.length;i++){
    if(total>=S.config.valorRules[i].valor_minimo){
      regra=S.config.valorRules[i];
      break;
    }
  }
  if(!regra)return;

  // Verifica se já tem brinde deste threshold — 1 fetch só, igual à regra de coleção
  cartTemBrinde(regra.valor_minimo,true).then(function(ja){
    if(ja)return;
    abrirPopupValor(regra);
  });
}

/* =========================================================
   REMOVER ÓRFÃOS
   ========================================================= */
function removerOrfaos(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=0;
    (cart.items||[]).forEach(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
    });

    (cart.items||[]).forEach(function(gift){
      if(!gift.properties||gift.properties[S.config.GIFT_PROP]!=='true')return;
      var remover=false;

      var from=gift.properties[S.config.GIFT_FROM];
      if(from&&!gift.properties[S.config.GIFT_FROM_VALOR]){
        var presente=(cart.items||[]).some(function(i){
          return i.handle===from&&(!i.properties||i.properties[S.config.GIFT_PROP]!=='true');
        });
        if(!presente)remover=true;
      }

      var fv=gift.properties[S.config.GIFT_FROM_VALOR];
      if(fv&&total<parseInt(fv,10))remover=true;

      if(remover){
        fetch('/cart/change.js',{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:gift.key,quantity:0})
        });
      }
    });
  }).catch(function(){});
}

/* =========================================================
   ABRIR POPUP — produto/coleção
   ========================================================= */
function abrirPopup(handle,afterFn){
  if(S.isOpen||S.isConfirm)return;
  var regra=S.config.rules[handle];
  if(!regra)return;

  S.isValorRule=false; S.valorMinimo=null;
  S.triggerHandle=handle; S.afterClose=afterFn||null;
  S.selectedBrindeHandle=null; S.selectedVariantId=null;

  if(typeof regra==='string')       S.brindes=[{handle:regra,imagem:null}];
  else if(Array.isArray(regra))     S.brindes=regra;
  else                               S.brindes=[regra];

  _abrirComBrindes();
}

/* =========================================================
   ABRIR POPUP — valor do carrinho
   ========================================================= */
function abrirPopupValor(regra){
  if(S.isOpen||S.isConfirm)return;
  S.isValorRule=true; S.valorMinimo=regra.valor_minimo;
  S.triggerHandle='__valor_'+regra.valor_minimo;
  S.afterClose=null;
  S.selectedBrindeHandle=null; S.selectedVariantId=null;
  S.brindes=regra.brindes;
  _abrirComBrindes();
}

function _abrirComBrindes(){
  mostrarOverlay();
  renderSkeleton();
  var promises=S.brindes.map(function(b){
    return fetch('/products/'+b.handle+'.js').then(function(r){return r.json();});
  });
  Promise.all(promises)
    .then(renderBrindes)
    .catch(function(){fecharEProsseguir();});
}

/* =========================================================
   RENDER
   ========================================================= */
function renderSkeleton(){
  document.getElementById('ceg-product-inner').innerHTML=
    '<div class="ceg-brindes-grid">'+
    '<div class="ceg-product__card ceg-skeleton-card">'+
    '<div class="ceg-product__image-wrap"><div class="ceg-skeleton" style="position:absolute;inset:0"></div></div>'+
    '<div class="ceg-product__info">'+
    '<div class="ceg-skeleton" style="height:16px;width:75%;margin-bottom:8px"></div>'+
    '<div class="ceg-skeleton" style="height:14px;width:45%;margin-bottom:12px"></div>'+
    '<div class="ceg-skeleton" style="height:36px;width:100%"></div>'+
    '</div></div></div>';
}

function renderBrindes(produtos){
  var disp=produtos.filter(function(p){
    return p.variants&&p.variants.some(function(v){return v.available;});
  });
  if(!disp.length){fecharEProsseguir();return;}

  var html='<div class="ceg-brindes-grid ceg-brindes-'+disp.length+'">';
  disp.forEach(function(product,idx){
    var available=product.variants.filter(function(v){return v.available;});
    var comp=product.compare_at_price_max||product.price;
    var imgCustom=S.brindes[idx]&&S.brindes[idx].imagem?S.brindes[idx].imagem:null;
    var img=imgCustom||product.featured_image||(product.images&&product.images[0])||'';
    var opts=available.map(function(v){return'<option value="'+v.id+'">'+v.title+'</option>';}).join('');
    var sel=(disp.length===1||idx===0)?'ceg-brinde-card--selected':'';
    html+=
      '<div class="ceg-brinde-card '+sel+'" data-handle="'+product.handle+'" data-idx="'+idx+'">'+
      '<div class="ceg-product__image-wrap">'+
      (img?'<img src="'+img+'" alt="'+product.title+'" loading="lazy">':'')+
      '<span class="ceg-product__free-tag">GRATIS</span>'+
      '</div>'+
      '<div class="ceg-product__info">'+
      '<h3 class="ceg-product__title">'+product.title+'</h3>'+
      '<div class="ceg-product__prices">'+
      '<span class="ceg-product__compare">'+fmt(comp)+'</span>'+
      '<span class="ceg-product__free-price">R$ 0,00</span>'+
      '</div>'+
      '<div class="ceg-variants">'+
      '<span class="ceg-variants__label">Selecione a opcao</span>'+
      '<select class="ceg-variants__select ceg-select-brinde" data-handle="'+product.handle+'">'+opts+'</select>'+
      '</div></div>'+
      (disp.length>1?'<div class="ceg-brinde-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>':'')+
      '</div>';
  });
  html+='<p class="ceg-variants__error" id="ceg-variant-error">Selecione uma opcao.</p></div>';

  document.getElementById('ceg-product-inner').innerHTML=html;

  S.selectedBrindeHandle=disp[0].handle;
  var fs=document.querySelector('.ceg-select-brinde');
  if(fs)S.selectedVariantId=parseInt(fs.value,10);

  document.querySelectorAll('.ceg-brinde-card').forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target&&e.target.tagName==='SELECT')return;
      selecionarCard(card);
    });
  });
  document.querySelectorAll('.ceg-select-brinde').forEach(function(s){
    s.addEventListener('change',function(e){
      e.stopPropagation();
      var card=s.closest('.ceg-brinde-card');
      if(card)selecionarCard(card);
      S.selectedVariantId=parseInt(s.value,10);
      var er=document.getElementById('ceg-variant-error');
      if(er)er.classList.remove('ceg-show');
    });
  });
}

function selecionarCard(card){
  document.querySelectorAll('.ceg-brinde-card').forEach(function(c){c.classList.remove('ceg-brinde-card--selected');});
  card.classList.add('ceg-brinde-card--selected');
  S.selectedBrindeHandle=card.dataset.handle;
  var s=card.querySelector('.ceg-select-brinde');
  if(s)S.selectedVariantId=parseInt(s.value,10);
  var er=document.getElementById('ceg-variant-error');
  if(er)er.classList.remove('ceg-show');
}

/* =========================================================
   ADICIONAR BRINDE
   ========================================================= */
function selecionarBrinde(){
  if(S.isAdding)return;
  if(!S.selectedVariantId){
    var er=document.getElementById('ceg-variant-error');
    if(er)er.classList.add('ceg-show');
    return;
  }
  S.isAdding=true;
  var btn=document.getElementById('ceg-btn-select');
  if(btn)btn.classList.add('ceg-loading');

  var props={};
  props[S.config.GIFT_PROP]='true';
  if(S.isValorRule) props[S.config.GIFT_FROM_VALOR]=''+S.valorMinimo;
  else              props[S.config.GIFT_FROM]=S.triggerHandle;

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:S.selectedVariantId,quantity:1,properties:props})
  }).then(function(r){
    if(!r.ok)throw new Error('cart/add falhou');
    return r.json();
  }).then(function(){
    var area=document.getElementById('ceg-product-area');
    if(area)area.innerHTML=
      '<div class="ceg-success">'+
      '<div class="ceg-success__icon">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">'+
      '<polyline points="20 6 9 17 4 12"></polyline></svg></div>'+
      '<h3>Brinde adicionado!</h3>'+
      '<p>Seu brinde foi adicionado ao carrinho gratuitamente.</p>'+
      '</div>';
    var ac=document.querySelector('.ceg-actions');if(ac)ac.style.display='none';
    var cc=document.getElementById('ceg-close');if(cc)cc.style.display='none';

    var noCart=window.location.pathname.indexOf('/cart')>-1;
    setTimeout(function(){
      fecharEProsseguir();
      if(noCart){
        setTimeout(function(){window.location.reload();},400);
      } else {
        setTimeout(function(){
          try{
            if(typeof theme!=='undefined'&&theme.cart&&theme.cart.drawer&&document.getElementById('ajaxDrawer')){
              theme.cart.drawer.reloadCart();
            }
          }catch(e){}
        },300);
      }
    },1800);
  }).catch(function(err){
    console.error('[CEG] Erro brinde:',err);
    if(btn)btn.classList.remove('ceg-loading');
    S.isAdding=false;
  });
}

/* =========================================================
   UI
   ========================================================= */
function mostrarOverlay(){
  S.isOpen=true;
  document.body.classList.add('ceg-body-lock');
  S.overlay.classList.remove('ceg-hidden');
  requestAnimationFrame(function(){requestAnimationFrame(function(){S.overlay.classList.add('ceg-visible');});});
}
function fecharEProsseguir(){
  S.overlay.classList.remove('ceg-visible');
  document.body.classList.remove('ceg-body-lock');
  var fn=S.afterClose;
  setTimeout(function(){
    S.overlay.classList.add('ceg-hidden');
    resetEstado();
    if(typeof fn==='function')fn();
  },350);
}
function resetEstado(){
  S.isOpen=false;S.isAdding=false;S.isConfirm=false;
  S.isValorRule=false;S.valorMinimo=null;
  S.triggerHandle=null;S.selectedBrindeHandle=null;
  S.selectedVariantId=null;S.afterClose=null;S.brindes=[];
  var a=document.querySelector('.ceg-actions');if(a)a.style.display='';
  var c=document.getElementById('ceg-close');if(c)c.style.display='';
  var i=document.getElementById('ceg-product-inner');if(i)i.innerHTML='';
}
function triggerDecline(){
  if(!S.isOpen)return;
  S.isConfirm=true;
  S.confirm.classList.remove('ceg-hidden');
  requestAnimationFrame(function(){S.confirm.classList.add('ceg-visible');});
}
function confirmarRecusa(){
  S.isConfirm=false;
  S.confirm.classList.remove('ceg-visible');
  setTimeout(function(){S.confirm.classList.add('ceg-hidden');},250);
  fecharEProsseguir();
}
function cancelarRecusa(){
  S.isConfirm=false;
  S.confirm.classList.remove('ceg-visible');
  setTimeout(function(){S.confirm.classList.add('ceg-hidden');},250);
}

function criarPopups(txt){
  document.querySelectorAll('.ceg-overlay,.ceg-confirm-overlay').forEach(function(e){e.remove();});
  document.body.insertAdjacentHTML('beforeend',
    '<div class="ceg-overlay ceg-hidden" id="ceg-overlay" role="dialog" aria-modal="true">'+
    '<div class="ceg-popup">'+
    '<button class="ceg-close-btn" id="ceg-close" aria-label="Fechar">'+
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">'+
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'+
    '<div class="ceg-header">'+
    '<div class="ceg-header__badge">Brinde desbloqueado</div>'+
    '<h2>'+txt.title+'</h2><p>'+txt.subtitle+'</p></div>'+
    '<div class="ceg-product" id="ceg-product-area"><div id="ceg-product-inner"></div></div>'+
    '<div class="ceg-actions">'+
    '<button class="ceg-btn ceg-btn--primary" id="ceg-btn-select">'+
    '<span class="ceg-btn-text">'+txt.btnSelect+'</span>'+
    '<span class="ceg-spinner"></span></button>'+
    '<button class="ceg-btn ceg-btn--ghost" id="ceg-btn-decline">'+txt.btnDecline+'</button>'+
    '</div></div></div>'+
    '<div class="ceg-confirm-overlay ceg-hidden" id="ceg-confirm-overlay" role="dialog" aria-modal="true">'+
    '<div class="ceg-confirm-popup">'+
    '<h3>'+txt.confirmTitle+'</h3><p>'+txt.confirmText+'</p>'+
    '<div class="ceg-confirm-actions">'+
    '<button class="ceg-btn ceg-btn--outline" id="ceg-confirm-no">'+txt.confirmNo+'</button>'+
    '<button class="ceg-btn ceg-btn--primary" id="ceg-confirm-yes">'+txt.confirmYes+'</button>'+
    '</div></div></div>'
  );
  S.overlay=document.getElementById('ceg-overlay');
  S.confirm=document.getElementById('ceg-confirm-overlay');
  S.overlay.addEventListener('click',function(e){if(e.target===S.overlay)triggerDecline();});
  document.getElementById('ceg-close').addEventListener('click',triggerDecline);
  document.getElementById('ceg-btn-select').addEventListener('click',selecionarBrinde);
  document.getElementById('ceg-btn-decline').addEventListener('click',triggerDecline);
  document.getElementById('ceg-confirm-no').addEventListener('click',confirmarRecusa);
  document.getElementById('ceg-confirm-yes').addEventListener('click',cancelarRecusa);
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    if(S.isConfirm)cancelarRecusa();
    else if(S.isOpen)triggerDecline();
  });
}

/* =========================================================
   URL HELPERS — captura /cart/add e /cart/add.js
   ========================================================= */
function isCartAddUrl(url){
  // Captura /cart/add e /cart/add.js mas nao /cart/add_discount etc
  return /\/cart\/add(\.js)?(\?|$)/.test(url);
}
function isCartChangeUrl(url){
  return /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
}

/* =========================================================
   PATCH FETCH
   ========================================================= */
var _lastClickedBtn=null;

function patchTema(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.product-form__submit');
    if(btn)_lastClickedBtn=btn;
  },true);

  var origFetch=window.fetch;
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url||'');

    /* cart/add.js */
    if(isCartAddUrl(url)&&init&&init.method&&init.method.toUpperCase()==='POST'){
      if(isGiftPayload(init.body))return origFetch.apply(this,arguments);

      var isBuyNow=_lastClickedBtn&&_lastClickedBtn.classList.contains('buy-now');
      _lastClickedBtn=null;

      return origFetch.apply(this,arguments).then(function(resp){
        if(!resp.ok)return resp;
        resp.clone().json().then(function(data){
          if(data.status)return;

          // Normaliza: BPM retorna objeto único, Shopify padrão retorna {items:[]}
          var items=Array.isArray(data.items)?data.items:data.handle?[data]:[];
          console.info('[CEG] add:',items.map(function(i){return i&&i.handle;}));

          // --- Regra por produto/coleção (mesma lógica de sempre) ---
          var handle=null;
          for(var i=0;i<items.length;i++){
            var it=items[i];
            if(!it||!it.handle)continue;
            if(it.properties&&it.properties[S.config.GIFT_PROP]==='true')continue;
            if(S.config.rules[it.handle]){handle=it.handle;break;}
          }
          if(handle){
            if(isBuyNow){
              // Buy-now: navega para /cart antes do .then() — salva pendencia
              try{sessionStorage.setItem('ceg_pending',handle);}catch(e){}
              // Tambem salva flag de valor para checar na pagina /cart
              try{sessionStorage.setItem('ceg_pending_valor','1');}catch(e){}
            } else {
              cartTemBrinde(handle,false).then(function(ja){
                if(!ja) abrirPopup(handle,null);
              });
            }
            return;
          }

          // --- Regra por valor ---
          if(!S.config.valorRules.length)return;

          if(isBuyNow){
            // Buy-now sem handle de produto: salva flag para checar na /cart
            try{sessionStorage.setItem('ceg_pending_valor','1');}catch(e){}
            return;
          }

          // Add normal: 1 fetch para /cart.js
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            var total=0;
            (cart.items||[]).forEach(function(i){
              if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
            });
            console.info('[CEG] total:',total,'threshold:',S.config.valorRules.map(function(r){return r.valor_minimo;}));
            checarRegrasValorComTotal(total);
          }).catch(function(){});

        }).catch(function(){});
        return resp;
      });
    }

    /* cart/change + cart/update: remove órfãos */
    if(isCartChangeUrl(url)&&
       init&&init.method&&init.method.toUpperCase()==='POST'){
      return origFetch.apply(this,arguments).then(function(r){
        debounce('orfaos',removerOrfaos,400);
        // Verifica se ainda tem valor suficiente ou se brinde deve ser mantido
        if(S.config.valorRules.length){
          fetch('/cart.js').then(function(r2){return r2.json();}).then(function(cart){
            var total=0;
            (cart.items||[]).forEach(function(i){
              if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
            });
            checarRegrasValorComTotal(total);
          }).catch(function(){});
        }
        return r;
      });
    }

    return origFetch.apply(this,arguments);
  };

  console.info('[CEG] v11 | produto/col:',Object.keys(S.config.rules).length,'| valor:',S.config.valorRules.length);
}

/* =========================================================
   BUY NOW PENDENTE
   ========================================================= */
function verificarPendenciaCarrinho(){
  if(window.location.pathname.indexOf('/cart')===-1)return;
  try{
    var handle=sessionStorage.getItem('ceg_pending');
    var pendValor=sessionStorage.getItem('ceg_pending_valor');
    if(!handle&&!pendValor)return;

    sessionStorage.removeItem('ceg_pending');
    sessionStorage.removeItem('ceg_pending_valor');

    // Espera o DOM e config estarem prontos
    function tentarAbrir(n){
      n=n||0;
      if(!S.config){
        var cfg=lerConfig();
        if(cfg){S.config=cfg;criarPopups(cfg.txt);}
        else{if(n<20)setTimeout(function(){tentarAbrir(n+1);},200);return;}
      }

      // 1. Popup de produto (handle especifico)
      if(handle&&S.config.rules[handle]){
        cartTemBrinde(handle,false).then(function(ja){
          if(ja) return;
          abrirPopup(handle,function(){
            // Ao fechar popup de produto, verifica regra de valor
            if(pendValor) verificarPendenciaValor();
          });
        });
        return;
      }

      // 2. Popup de valor
      if(pendValor) verificarPendenciaValor();
    }

    setTimeout(function(){tentarAbrir(0);},600);
  }catch(e){}
}

function verificarPendenciaValor(){
  if(!S.config||!S.config.valorRules.length)return;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=0;
    (cart.items||[]).forEach(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
    });
    checarRegrasValorComTotal(total);
  }).catch(function(){});
}

/* =========================================================
   BOOT
   ========================================================= */
function boot(){
  var config=lerConfig();
  if(!config)return;
  S.config=config;
  criarPopups(config.txt);
  patchTema();
  verificarPendenciaCarrinho();

  // Remove órfãos ao carregar
  debounce('orfaos_boot',removerOrfaos,1500);

  // Eventos nativos do tema BPM
  ['cart:updated','cart:item-removed','cart:refreshed'].forEach(function(ev){
    document.addEventListener(ev,function(){
      debounce('orfaos',removerOrfaos,400);
      if(S.config.valorRules.length){
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var total=0;
          (cart.items||[]).forEach(function(i){
            if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
          });
          checarRegrasValorComTotal(total);
        }).catch(function(){});
      }
    });
  });
}

window.CEG_DEBUG=S;
window._cegAbrirPopup=function(h,a){abrirPopup(h,a);};

function tryBoot(n){
  if(!document.getElementById('ceg-section-config')&&(n||0)<30){
    setTimeout(function(){tryBoot((n||0)+1);},100);return;
  }
  boot();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){tryBoot(0);});
}else{
  tryBoot(0);
}

})();
